import { useContext, useEffect, useState } from 'react'

import { Modal, Input } from '../ui_new'
import { SingleDocumentContext, UserContext } from '../../context'
import { CircularProgress } from '@mui/material'

const SharedDocumentPasswordModal = ({ onSubmit, error }) => {
  
  const { user } = useContext(UserContext)
  const { document } = useContext(SingleDocumentContext)

  const [password, setPassword] = useState('')
  const [passwordError, setPasswordError] = useState(null)
  const [loading, setLoading] = useState(false)

  const sharedBy = document?.sharedBy
  const author = document?.author
  const authorName = `${(sharedBy || author)?.firstname} ${(sharedBy || author)?.lastname}`
  const authorLabel = authorName.trim() ? authorName : 'l’auteur du document'

  useEffect(() => {
    setPasswordError(error)
  }, [error])

  const handleChangePassword = (e) => {
    const value = e.target.value
    setPassword(value)
    setPasswordError(null) // Reset error on change
  }

  const handleSubmit = async () => {
    if (password.trim() === '') {
      setPasswordError('Le mot de passe est requis')
      return
    }
    setLoading(true)
    await onSubmit(password)
    setLoading(false)
  }

  return (
    <Modal className="modal-v2 modal-v2--mid modal-v2--z-index-top modal-v2--blur">
      <div className='modal-v2__heading'>
        <div>
          <h2>Connexion</h2>
        </div>
        <div className="buttons-row">
          <button className='btn btn--primary btn--medium' onClick={handleSubmit} disabled={loading}>
            {loading && <CircularProgress size={16} className='mr-2' />}
            {loading ? 'Chargement...' : 'Connexion'}
          </button>
        </div>
      </div>
      <div className='modal-v2__body'>
        <p className="share-warning--text">          
          Vous souhaitez accéder au document transmis par {authorLabel} ? Pour cela renseigner le mot de passe fournis par {user?.email || 'votre adresse e-mail'}. 
        </p>
        <div className="comment-form pb-4">
          <div className="input-wrapper">
            <Input
              value={password}
              type="password"
              onChange={handleChangePassword}
              className={password ? 'not-empty' : ''}
              label={'Mot de passe'}
              placeholder=' - '
              error={passwordError}
              required />
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default SharedDocumentPasswordModal
